module.exports = __webpack_public_path__ + "media/images/athletes/1799-9495b752bed71e6d93decf7f5d3807d0.png";